module.exports = __webpack_public_path__ + "static/media/mujer-hombre2.0bf54caf.jpg";